/* eslint-disable import/no-cycle */
import { useEffect, useState, useMemo } from 'react'
import { IProductSearch } from '@core/api/Products/types'
import useChannel from '@core/hooks/channel/useChannel'

const useBundleItemSelection = (items?: IProductSearch[]) => {
  const { userChannel } = useChannel()
  const [selectedItems, setSelectedItems] = useState<IProductSearch[]>([])

  useEffect(() => {
    if (!items) return
    setSelectedItems(items)
  }, [items])

  const isSelected = (item: IProductSearch) => {
    return selectedItems.includes(item)
  }

  const select = (itemToSelect: IProductSearch, value: boolean) => {
    if (value && !isSelected(itemToSelect)) {
      setSelectedItems([...selectedItems, itemToSelect])
    }
    if (!value && isSelected(itemToSelect)) {
      setSelectedItems(selectedItems.filter((item) => item !== itemToSelect))
    }
  }

  const productBundlePrice = useMemo(() => {
    if (!userChannel) return 0

    return selectedItems.reduce((acc, product) => {
      if (product.mainVariant.packagingUnits[0].price) {
        return (
          acc +
          product.mainVariant.packagingUnits[0].price[
            userChannel.displayedPriceType
          ]
        )
      } else {
        return acc + 0
      }
    }, 0)
  }, [selectedItems, userChannel])

  return {
    selectedBundleItems: selectedItems,
    productBundlePrice,
    isSelected,
    select,
  }
}

export default useBundleItemSelection
